export default __webpack_public_path__ + "a3ef46c35c4ef66e668047c3d25391f2.png";